export default __webpack_public_path__ + "static/bg-6493f72ca29795165ffdcf04997b9d1e.png";